<template>
    <div class="bg-white pt-16 pb-10">
        
        <section class="max-w-4xl mx-auto p-6 mt-10 bg-white bg-opacity-80 backdrop-blur-lg rounded-2xl shadow-lg">
            <h1 class="text-3xl font-bold text-gray-900 mb-6 text-center">Privacy Policy</h1>

            <article class="space-y-6 text-gray-800">
                 <div v-html="data?.content"></div>
            </article>
        </section>
    </div>
  
</template>

<script>
import AuthService from "@/services/auth.service";
import webContentService from "@/services/web-content.service";
export default {
  data() {
    return {
     tenant:{},
     data:{},
     query:'privacy-policy'

        
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  async mounted() {
     AuthService.getDataTenant().then(
        (response) => {
        var data = response.data;
        this.tenant = data;
        this.webSiteContent(this.tenant.id, this.tenant.code,this.query);
        },
        (error) => {
        this.content =
            (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();
        }
    );
    

    
  },
  methods:{
    webSiteContent(id,code, query){
      webContentService.getData(id,code, query).then(
        (response) => {
        var data = response.data.data[0];
        this.data = data;
        },
        (error) => {
        this.content =
            (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();
        }
    );
    }
  }
};
</script>
